<template>
  <div class="containerTable">
    <vxe-toolbar
      id="toolbarId_cu10"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('shipperInvoice_search_button')"
          @click="funcFilter()"
        >
          查询
        </el-button>
        <el-button
          v-if="getLimit('shipperInvoice_get_button')"
          @click="getSelectEvent()"
        >
          索取发票
        </el-button>
        <el-button
          v-if="getLimit('shipperInvoice_export_button')"
          @click="funcExport()"
        >
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :loading="loading"
      :data="tableData"
      :checkbox-config="{ highlight: true }"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="mainOrderNumber"
          title="货源单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.mainOrderNumber"
            placeholder="货源单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运输单号"
          min-width="250"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="运输单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentName"
          title="托运人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipmentName"
            placeholder="托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxPrice"
          title="单价"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.taxPriceStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.taxPriceEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="billingType"
          title="开票方式"
          :formatter="formatterBillingType"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.billingType"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in billingTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="loadQuantity"
          title="装车重量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.loadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.loadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="unloadQuantity"
          title="卸车重量"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.unloadQuantityStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.unloadQuantityEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperName"
          title="发货联系人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperName"
            placeholder="发货联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperPhone"
          title="装货电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperPhone"
            placeholder="装货电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperAddress"
          title="装货地址"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.shipperAddress"
            placeholder="装货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeName"
          title="卸货联系人"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeName"
            placeholder="卸货联系人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneePhone"
          title="收货电话"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneePhone"
            placeholder="收货电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="consigneeAddress"
          title="收货地址"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.consigneeAddress"
            placeholder="收货地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="gmtCreated"
          title="创建时间"
          min-width="420"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.gmtCreatedRange"
            value-format="yyyy-MM-dd"
            type="daterange"
            :picker-options="optionsPicker"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="value => changeDate(value, 'gmtCreated')"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column field="action" title="操作" fixed="right" width="50">
        <template slot-scope="scope">
          <el-tooltip
            v-if="getLimit('shipperInvoice_detail_button')"
            class="item"
            effect="dark"
            content="详情"
            placement="top"
          >
            <vxe-button type="text" @click="funcDetail(scope.row.code)">
              <i class="el-icon-document" />
            </vxe-button>
          </el-tooltip>
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <vxe-modal
      v-model="modelDetailFlag"
      title="详情"
      width="1000"
      height="600"
      resize
    >
      <compDetail ref="detailRef" />
    </vxe-modal>
    <vxe-modal
      v-model="Askfor"
      title="发票索取"
      width="1000"
      height="600"
      resize
    >
      <requestlist ref="invoiceRef" @event1="receive" />
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getTranslateInvoiceJinChang } from "@/api/invoice";
import compDetail from "@/components/WaybillDetails";
import requestlist from "./components/requestlist.vue";
export default {
  name: "Parent",
  components: {
    compDetail,
    requestlist
  },
  data() {
    return {
      loading: false,
      Askfor: false,
      tableData: [],
      modelDetailFlag: false,
      exportObj: {
        exportUrl: "/ntocc-basic-api/invoice/exportTranslateInvoiceJinChang", //导出接口
        name: "托运人开票"
      },
      listQuery: {
        gmtCreatedRange: "",
        pageNum: 1,
        pageSize: 20,
        total: 0,
        billingType: ""
      },
      statusOptions: [
        { label: "申请开票", value: 0 },
        { label: "已取消", value: 1 },
        { label: "已开票", value: 2 }
      ],
      billingTypeOptions: [
        { label: "现付开票", value: 0 },
        { label: "到付开票", value: 1 },
        { label: "代付开票", value: 2 }
      ],
      codes: [],
      code: "",
      type2: [],
      types: {
        type: ""
      }
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getTranslateInvoiceJinChang(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 详情方法
    funcDetail(code) {
      this.$refs.detailRef.Getdetails(code);
      this.modelDetailFlag = true;
    },

    // 代发托运人子组件向父组件传值
    receive() {
      this.Askfor = false;
      this.findList();
    },
    // 状态
    formatterStatus({ cellValue }) {
      const item = this.statusOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    formatterBillingType({ cellValue }) {
      const item = this.billingTypeOptions.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    // 索取方法
    getSelectEvent() {
      const selectRecords = this.$refs.xTable.getSelectRecords();
      if (selectRecords.length === 0) {
        this.$message({ message: "请选择订单", type: "warning" });
        return false;
      }
      let types = selectRecords.map(item => item.billingType);
      let shipperCodeArr = selectRecords.map(item => item.shipmentCode);
      let codesArr = selectRecords.map(item => item.code);
      let isCommonCode = false;
      shipperCodeArr.forEach(code => {
        if (code !== shipperCodeArr[0]) isCommonCode = true;
      });
      if (isCommonCode) {
        this.$message({
          message: "只能选择同一个托运人的运单！",
          type: "warning"
        });
        return false;
      }
      let repeat = false;
      types.forEach(str => {
        if (str !== types[0]) repeat = true;
      });
      if (repeat) {
        this.$message({
          message: "只能选择同一种开票方式的运单！",
          type: "warning"
        });
        return false;
      } else {
        // const codes = shipperCodeArr[0]
        let codes = codesArr.join(",");
        this.$refs.xTable.clearCheckboxRow();
        this.$refs.invoiceRef.invoicelist(types[0], shipperCodeArr[0], codes);
        this.Askfor = true;
      }
    },
    InvoiceInquiry() {
      this.loading = true;
      getTranslateInvoiceJinChang(this.listQuery).then(response => {
        this.tableData = response.data.records;
        this.listQuery.total = response.data.total;
        this.loading = false;
      });
    },
    // 公共取消
    fatherCancel(modelFlag) {
      if (modelFlag == "detail") {
        this.modelDetailFlag = false;
      }
    }
  }
};
</script>

<style></style>
